const React = require('react');
const PropTypes = require('prop-types');

const injectI18n = require('nordic/i18n/injectI18n');
const Head = require('nordic/head');

const Page = require('../../components/Page');
const IconMercadoPagoVertical = require('../../components/icons/MercadoPagoVertical');

const styles = {
  block: {
    paddingTop: '1.5em',
    paddingBottom: '1em',
    textAlign: 'center',
    position: 'absolute',
    width: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    left: '0',
  },
  icon: {
    display: 'block',
    marginBottom: '2em',
  },
  title: {
    fontSize: '1em',
    color: '#333',
  },
};

const Crawler = ({ stepTitle, currentStep, deviceType, crawlerData }) => (
  <Page
    title={stepTitle}
    currentStep={currentStep}
    deviceType={deviceType}
  >
    <Head>
      <meta property="og:url" content={crawlerData.url} />
      <meta property="og:site_name" content={crawlerData.site_name} />
      <meta property="og:title" content={crawlerData.title} />
      <meta property="og:description" content={crawlerData.description} />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={crawlerData.image} />
      {crawlerData.width && <meta property="og:image:width" content={crawlerData.width} />}
      {crawlerData.height && <meta property="og:image:height" content={crawlerData.height} />}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@mercadopago" />
      <meta name="twitter:title" content={crawlerData.title} />
      <meta name="twitter:description" content={crawlerData.description} />
      <meta name="twitter:creator" content="@mercadopago" />
      <meta name="twitter:image" content={crawlerData.image} />
    </Head>
    <div style={styles.block}>
      <span style={styles.icon}>
        <IconMercadoPagoVertical />
      </span>
    </div>
  </Page>
);

/**
 * Default Values
 */
Crawler.defaultProps = {
  crawlerData: {
    stepTitle: '',
    currentStep: '',
    deviceType: '',
    image: '',
    title: '',
    url: '',
    description: '',
    width: '',
    height: '',
    site_name: '',
  },
};

/**
 * PropTypes
 */
Crawler.propTypes = {
  crawlerData: PropTypes.shape({
    stepTitle: PropTypes.string,
    currentStep: PropTypes.string,
    deviceType: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    description: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    site_name: PropTypes.string,
  }),
};

module.exports = injectI18n(Crawler);
